export default "__VITE_ASSET__076a6f59__"